
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MapPin, Star, Building, TrendingUp } from "lucide-react";
import { useCountryAnalytics } from "@/hooks/useCountryAnalytics";

const TopCountriesWidget = () => {
  const { data, isLoading } = useCountryAnalytics();

  if (isLoading) {
    return (
      <Card className="bg-white/80 backdrop-blur-sm border-slate-200/60">
        <CardContent className="p-6">
          <div className="animate-pulse space-y-4">
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            <div className="space-y-3">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="h-16 bg-gray-200 rounded"></div>
              ))}
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="bg-white/80 backdrop-blur-sm border-slate-200/60">
      <CardHeader>
        <CardTitle className="text-xl font-bold text-slate-800 flex items-center gap-2">
          <MapPin className="w-5 h-5 text-red-600" />
          أفضل الوجهات السياحية
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {data?.topCountries?.slice(0, 6).map((country, index) => (
            <div key={country.country} className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                    {index + 1}
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-800">{country.country}</h3>
                    <p className="text-sm text-slate-600">
                      {country.tours} جولة سياحية
                    </p>
                  </div>
                </div>
                <Badge variant="secondary" className="text-green-700 bg-green-100">
                  {country.totalValue.toLocaleString('ar-SA')} ر.س
                </Badge>
              </div>
              
              <div className="grid grid-cols-3 gap-4 text-sm">
                <div className="flex items-center gap-1 text-slate-600">
                  <TrendingUp className="w-4 h-4" />
                  <span>متوسط: {country.averagePrice.toLocaleString('ar-SA')} ر.س</span>
                </div>
                <div className="flex items-center gap-1 text-slate-600">
                  <Building className="w-4 h-4" />
                  <span>{country.hotels} فندق</span>
                </div>
                <div className="flex items-center gap-1 text-slate-600">
                  <Star className="w-4 h-4" />
                  <span>رقم {index + 1}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default TopCountriesWidget;
